import React, { Suspense, ReactElement } from "react";
import remarkGfm from 'remark-gfm';
import { ReactMarkdownOptions } from "react-markdown/lib/react-markdown";
import { Components } from "react-markdown";

const ReactMarkdown = React.lazy(() => import('react-markdown'));

// Improved utility function
const getAdjustedPath = (path: string): string => {
  if (!path || !path.startsWith('/')) {
    return path;
  }

  const basePath = process.env.PUBLIC_URL || '';

  // If basePath is empty or path already starts with basePath, return path unchanged
  if (!basePath || path.startsWith(basePath)) {
    return path;
  }

  return `${basePath}${path}`;
};

const ReactMarkdownWrap = (props: ReactMarkdownOptions): ReactElement => {
  // Create custom components with link handling
  const components: Components = {
    ...(props.components || {}),
    a: ({ href, ...restProps }) => {
      // Only adjust internal links that start with /
      const adjustedHref = href?.startsWith('/')
        ? getAdjustedPath(href)
        : href;

      // Use the default a component
      return <a href={adjustedHref} {...restProps} />;
    }
  };

  return (
    <Suspense fallback={<div />}>
      <ReactMarkdown
        {...props}
        components={components}
        remarkPlugins={[remarkGfm]}
      />
    </Suspense>
  );
};

export default ReactMarkdownWrap;
